import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Maybe } from "@ispb/react-hooks";
import { LOADING_ICON } from "../icons";
export default function LoadingPage(props) {
    return (_jsxs("div", { className: "d-flex flex-grow-1 flex-column text-center align-items-center justify-content-center", children: [_jsx(Maybe, { value: props.title, children: title => _jsx("h1", { className: "display-2 mb-0 fw-bold", children: title }) }), _jsx(FontAwesomeIcon, { ...LOADING_ICON, style: { fontSize: "40vh", marginTop: "4vh" } })] }));
}
